'use strict';

module.exports = {
    /**
     * 关闭当前网页窗口接口
     * @method hysdk.closeWindow
     * @category Fusion:Window
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    closeWindow: {
        service: 'Util',
        action: 'backToLast',
        tagname: 'back_to_last_page'
    },
    hideOptionMenu: false,
    showOptionMenu: false,
    hideMenuItems: false,
    showMenuItems: false,
    hideAllNonBaseMenuItem: false,
    showAllNonBaseMenuItem: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/window.js
// module id = 52
// module chunks = 1 4